/**
 * v19
 * added new columns for stock on the itemVariant table
 */

import { type Transaction } from 'dexie';
import { type LegacyItemVariant } from '../../models';

export const schemaV19 = {
    taxes: 'id, name, value, deleted, [id+deleted]',
    paymentMethods:
        'id, name, type, deleted, enabled, [id+deleted], [enabled+deleted]',
    staff: 'id, authUserId, role, deleted, registerPin, [registerPin+deleted], [id+deleted]',

    items: 'id, name, itemType, categoryId, measurementUnitId, isActive, [id+isActive], nameLower, *searchTokens',
    itemVariants:
        'id, name, sku, barcode, itemPriceType, itemId, deleted, currentStock, [id+deleted], [itemId+deleted], [sku+deleted], [barcode+deleted]',

    itemVariantCompositions:
        'id, variantId, deleted, [id+deleted], parentVariantId, [parentVariantId+deleted]',

    categories: 'id, name, deleted, [id+deleted]',
    measurementUnits: 'id, name, deleted, [id+deleted]',

    discounts: 'id, hasRules, deleted, *customerGroupIds, [hasRules+deleted]',

    carts: 'id, createdAt, version',
    terminals: 'serialNumber',
};

export async function v19Upgrade(transaction: Transaction) {
    return transaction
        .table('itemVariants')
        .toCollection()
        .modify((variant: LegacyItemVariant) => {
            variant.currentStock = variant.stockDetail?.currentStock;
            variant.lowStockAlert = variant.stockDetail?.lowStockAlert;
            variant.stockDetail = null;
        });
}
